exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.myexchange .vux-tab-bar-inner {\n    border-radius: 3px !important;\n}\n", ""]);

// exports
